function addQuestion() {
  const questionsEl = document.querySelector('.questions');
  const html = TIML.parseLayout(FormsCustomQuestion, '');
  questionsEl.append(html);
}

function moveQuestionUp(el) {
  const li = el.closest('li');
  const prev = li.previousElementSibling;
  if (prev) {
    li.parentNode.insertBefore(li, prev);
  }
}

function moveQuestionDown(el) {
  const li = el.closest('li');
  const next = li.nextElementSibling;
  if (next) {
    li.parentNode.insertBefore(next, li);
  }
}

function deleteQuestion(el) {
  el.closest('li').remove();
}

function changeQuestionType(el) {
  const question = el.parentElement.parentElement;
  const options = question.querySelector('.question-options');
  if (el.value === "Radio" || el.value === "Checkbox") {
    if (!options.querySelector('textarea')) {
      options.append(TIML.parseLayout(FormsCustomQuestionOption, ''));
    }
  } else {
    options.innerHTML = "";
  }
}

globalThis.addQuestion = addQuestion;
globalThis.moveQuestionUp = moveQuestionUp;
globalThis.moveQuestionDown = moveQuestionDown;
globalThis.deleteQuestion = deleteQuestion;
globalThis.changeQuestionType = changeQuestionType;

class FormsCustomQuestion {
  static timl = `
    li.question
      .question-header
        select.custom-question-type[onchange="changeQuestionType(this)"]
          option Input
          option Radio
          option Checkbox
          option Textarea
          option Paragraph
        a.question-delete-button[onclick="deleteQuestion(this)"] x
        a#move-question-down-button[onclick="moveQuestionDown(this)"] down
        a#move-question-up-button[onclick="moveQuestionUp(this)"] up
      label.touched
        span Question
        textarea[name="label" placeholder=""]
      .question-options
  `;
}

class FormsCustomQuestionOption {
  static timl = `
    label.touched
      span Options
      textarea[name="label" placeholder="Write each option on a new line" oninput="this.style.height='auto'; this.style.height=this.scrollHeight + 'px';"]
  `;
}

export { addQuestion, moveQuestionUp, moveQuestionDown, deleteQuestion, changeQuestionType };
